module.exports = __webpack_public_path__ + "static/media/chicago-bulls.2e1b7b20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/chicago-bulls.svg
// module id = 231
// module chunks = 0